import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { InvestmentHttpRepository, InvestmentDummyRepository } from './infrastructure/repository';

// Application
import { SearchInvestmentsQuery } from './application/queries';

// Domain
import { InvestmentRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupInvestment(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_KUSPIT_INVESTMENT_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<InvestmentRepository>(TYPES.CATALOG_KUSPIT_INVESTMENT_REPOSITORY)
    .to(
      withDummies
        ? InvestmentDummyRepository
        : InvestmentHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchInvestmentsQuery>(
      TYPES.SEARCH_CATALOG_KUSPIT_INVESTMENT_QUERY,
    )
    .to(SearchInvestmentsQuery)
    .inSingletonScope();
}
